// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mlwOdHEOwkhCwsiO2Djz {
  /* text-align: right;
  margin: 10px 10px 0 80px;
  top: -35px;
  left: -15px;  */
  /* padding-left: 20px; */
  position: relative;
}

.nNpFk9Ip695T62tlGht9 {
  padding-top: 10px;
  display: flex;
  gap: 10px;
}

.jApdb1FyBUoho2xOzNk_ {
  display: inline-block;
  cursor: pointer;
}

.BlfPWGvB5bndML7SJUYM {
  padding-bottom: 10px;
  width: 200px;
  align-items: center;
  display: flex;
  margin-left: 31px;
  grid-gap: 50px;
  grid-gap: 20px;
  gap: 20px;
}

.KFqLuUqBfNdrAJbqr20S {
  /* padding-top: 20px; */
  height: calc(100vh - 190px);
  overflow: auto;
  margin: 0px 20px 0px 30px;
}

.BlfPWGvB5bndML7SJUYM input {
  padding: 10px;
  height: 35px;
}

.BlfPWGvB5bndML7SJUYM button {
  height: 35px;
  width: 70px;
  margin-left: -70px;
  border: none;
  background-color: #1976d2;
  color: white;
  cursor: pointer;
}

.RGV0KPEPxE__L79EiSGJ {
  height: calc(100vh - 190px);
  overflow-y: auto;
  overflow-wrap: break-word;
}

.RGV0KPEPxE__L79EiSGJ::-webkit-scrollbar {
  width: 3px;
}

.RGV0KPEPxE__L79EiSGJ::-webkit-scrollbar-thumb {
  background-color: gray;
}

.xSDzQOssGRRLjny65e8E {
  text-align: left;
  margin-bottom: 10px;
}

.GBWvBEXWEf8ETS4V8RsY {
  font-weight: 500;
}

@media only screen and (max-width: 778px) {
  .mlwOdHEOwkhCwsiO2Djz {
    padding: 0px;
  }
  .BlfPWGvB5bndML7SJUYM {
    display: flex;
    justify-content: flex-end;
    grid-gap: 50px;
    gap: 20px;
    position: relative;
    padding-right: 25px;
    top: 16px;
    right: 0px;
    text-align: center;
    padding-left: 10px;
    margin-bottom: 25px;
  }
  .KFqLuUqBfNdrAJbqr20S {
    margin: 0px;
    padding-bottom: 90px;
  }
}`, "",{"version":3,"sources":["webpack://./components/Dashboard/dashboard.module.css"],"names":[],"mappings":"AAAA;EACE;;;iBAAA;EAIA,wBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,SAAA;AACF;;AAEA;EACE,uBAAA;EACA,2BAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,2BAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;EAEA;IACE,aAAA;IACA,yBAAA;IACA,cAAA;IACA,SAAA;IACA,kBAAA;IACA,mBAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,kBAAA;IACA,mBAAA;EAAF;EAGA;IACE,WAAA;IACA,oBAAA;EADF;AACF","sourcesContent":[".logs {\n  /* text-align: right;\n  margin: 10px 10px 0 80px;\n  top: -35px;\n  left: -15px;  */\n  /* padding-left: 20px; */\n  position: relative;\n}\n\n.topbar {\n  padding-top: 10px;\n  display: flex;\n  gap: 10px;\n}\n\n.copyable-text {\n  display: inline-block;\n  cursor: pointer;\n}\n\n.log_bar {\n  padding-bottom: 10px;\n  width: 200px;\n  align-items: center;\n  display: flex;\n  margin-left: 31px;\n  grid-gap: 50px;\n  grid-gap: 20px;\n  gap: 20px;\n}\n\n.logsbackground {\n  /* padding-top: 20px; */\n  height: calc(100vh - 190px);\n  overflow: auto;\n  margin: 0px 20px 0px 30px;\n}\n\n.log_bar input {\n  padding: 10px;\n  height: 35px;\n}\n\n.log_bar button {\n  height: 35px;\n  width: 70px;\n  margin-left: -70px;\n  border: none;\n  background-color: #1976d2;\n  color: white;\n  cursor: pointer;\n}\n\n.logsItems {\n  height: calc(100vh - 190px);\n  overflow-y: auto;\n  overflow-wrap: break-word;\n}\n\n.logsItems::-webkit-scrollbar {\n  width: 3px;\n}\n\n.logsItems::-webkit-scrollbar-thumb {\n  background-color: gray;\n}\n\n.log {\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.paralog {\n  font-weight: 500;\n}\n\n@media only screen and (max-width: 778px) {\n  .logs {\n    padding: 0px;\n  }\n\n  .log_bar {\n    display: flex;\n    justify-content: flex-end;\n    grid-gap: 50px;\n    gap: 20px;\n    position: relative;\n    padding-right: 25px;\n    top: 16px;\n    right: 0px;\n    text-align: center;\n    padding-left: 10px;\n    margin-bottom: 25px;\n  }\n\n  .logsbackground {\n    margin: 0px;\n    padding-bottom: 90px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logs": `mlwOdHEOwkhCwsiO2Djz`,
	"topbar": `nNpFk9Ip695T62tlGht9`,
	"copyable-text": `jApdb1FyBUoho2xOzNk_`,
	"log_bar": `BlfPWGvB5bndML7SJUYM`,
	"logsbackground": `KFqLuUqBfNdrAJbqr20S`,
	"logsItems": `RGV0KPEPxE__L79EiSGJ`,
	"log": `xSDzQOssGRRLjny65e8E`,
	"paralog": `GBWvBEXWEf8ETS4V8RsY`
};
export default ___CSS_LOADER_EXPORT___;
